import { render, staticRenderFns } from "./smsmessages.vue?vue&type=template&id=2b5058a6&"
import script from "./smsmessages.vue?vue&type=script&lang=js&"
export * from "./smsmessages.vue?vue&type=script&lang=js&"
import style0 from "./smsmessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports